import React from 'react';
import { useState, useEffect } from 'react';
import Chart from 'chart.js/auto';
import { Line } from 'react-chartjs-2';
import Tables from './btcTable';
Chart.defaults.font.size = 25;
Chart.defaults.font.family = 'Helvetica';

export default function Recent() {
  let [state, setState] = useState({
    labels: [1, 2, 3, 4, 5, 6, 8],
    datasets: [
      {
        label: 'Bit Coin',
        fill: true,
        backgroundColor: 'rgb(123, 184, 234,0.2)',
        borderColor: '#2289dd',
        data: [
          28350.287554398325, 28392.066809334752, 28390.408684949918,
          28413.902412928677, 28413.45761878715, 28425.29302398287,
          28335.225275836485,
        ],
      },
    ],
  });

  let CryptoCurruncy = async () => {
    let fetchs = await fetch(
      'https://data.messari.io/api/v1/assets/btc/metrics'
    );
    let a = await fetchs.json();
    state.datasets[0].data.shift();
    state.datasets[0].data.push(a.data.market_data.price_usd);
    setState({
      ...state,
      datasets: [{ ...state.datasets[0], data: state.datasets[0].data }],
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      CryptoCurruncy();
    }, 3000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      <div
        style={{ fontWeight: 'bold', fontSize: '40px', background: '#f4f4f4' }}
      >
        <h1>{state.price}</h1>
        <div className="container pt-3 pb-3">
          <Line data={state} style={{ width: '100%' }} />
        </div>
      </div>
      <div>
        <div
          className="text-center pt-5"
          style={{
            fontWeight: 'bold',
            fontSize: '40px',
            color: 'rgb(54 105 217)',
          }}
        >
          Crypto News Table
        </div>
        <div className="pt-5">
          <Tables />
        </div>
      </div>
    </>
  );
}
